// Stock Issue Action Types
export const FETCH_STOCK_ISSUES_REQUEST = 'FETCH_STOCK_ISSUES_REQUEST';
export const FETCH_STOCK_ISSUES_SUCCESS = 'FETCH_STOCK_ISSUES_SUCCESS';
export const FETCH_STOCK_ISSUES_FAILURE = 'FETCH_STOCK_ISSUES_FAILURE';
export const CREATE_STOCK_ISSUE_SUCCESS = 'CREATE_STOCK_ISSUE_SUCCESS';
export const MARK_STOCK_ISSUE_RECEIVED_SUCCESS = 'MARK_STOCK_ISSUE_RECEIVED_SUCCESS';
export const DELETE_STOCK_ISSUE_SUCCESS = 'DELETE_STOCK_ISSUE_SUCCESS';
export const FETCH_STOCK_ISSUES_BY_EMPLOYEE_SUCCESS = 'FETCH_STOCK_ISSUES_BY_EMPLOYEE_SUCCESS';
export const FETCH_STOCK_ISSUES_BY_BATCH_SUCCESS = 'FETCH_STOCK_ISSUES_BY_BATCH_SUCCESS';
export const FETCH_UNIQUE_EMPLOYEES_SUCCESS = 'FETCH_UNIQUE_EMPLOYEES_SUCCESS';
export const FETCH_UNIQUE_BATCHES_SUCCESS = 'FETCH_UNIQUE_BATCHES_SUCCESS';

// Stock Received Report Action Types
export const FETCH_STOCK_RECEIVED_REPORT_REQUEST = 'FETCH_STOCK_RECEIVED_REPORT_REQUEST';
export const FETCH_STOCK_RECEIVED_REPORT_SUCCESS = 'FETCH_STOCK_RECEIVED_REPORT_SUCCESS';
export const FETCH_STOCK_RECEIVED_REPORT_FAILURE = 'FETCH_STOCK_RECEIVED_REPORT_FAILURE'; 